export default __webpack_public_path__ + "static/cardTabImg1-ba982709a08a7b765b0f9414590214e1.webp";